import "./style.css";
import HTML from "../../assets/icons/html.svg";
import CSS from "../../assets/icons/css.svg";
import JS from "../../assets/icons/javascript.svg";
import Bootstrap from "../../assets/icons/bootstrap.svg";
import MUI from "../../assets/icons/mui.svg";
import Tailwind from "../../assets/icons/tailwind.svg";
import ReactIcon from "../../assets/icons/react.svg";
import Angular from "../../assets/icons/angular.svg";
import Typescript from "../../assets/icons/typescript.svg";
import ReactNative from "../../assets/icons/react-native.svg";
import Firebase from "../../assets/icons/firebase.svg";
import NodeJS from "../../assets/icons/node-js.svg";
import Mongo from "../../assets/icons/mongo.svg";
import SQL from "../../assets/icons/database.svg";
import Ionic from "../../assets/icons/ionic.svg";
import Parse from "../../assets/icons/parse.svg";
import Artificial from "../../assets/icons/artificial.svg";
import Rocket from "../../assets/icons/rocket.svg";
import Camping from "../../assets/icons/camping.svg";
import Climbing from "../../assets/icons/climbing.svg";
import Reading from "../../assets/icons/reading.svg";
import Chess from "../../assets/icons/chess.svg";
import { useLanguage } from "../../context/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about">
      <div className="row section-intro">
        <div className="col-twelve">
          <h5>{t("about.title")}</h5>
          <h1>{t("about.subtitle")}</h1>

          <div className="intro-info">
            <p className="lead">{t("about.description")}</p>
          </div>
        </div>
      </div>

      <div className="row about-content">
        <div className="col-twelve">
          <h3>{t("about.interests")}</h3>

          <div className="skills">
            <div className="skill">
              <img src={Artificial} alt="Artificial Intelligence" />
              <span>{t("about.artificialIntelligence")}</span>
            </div>
            <div className="skill">
              <img src={Chess} alt="Chess" />
              <span>{t("about.chess")}</span>
            </div>
            <div className="skill">
              <img src={Rocket} alt="Astronomy" />
              <span>{t("about.astronomy")}</span>
            </div>
            <div className="skill">
              <img src={Camping} alt="Camping" />
              <span>{t("about.camping")}</span>
            </div>
            <div className="skill">
              <img src={Climbing} alt="Climbing" />
              <span>{t("about.climbing")}</span>
            </div>
            <div className="skill">
              <img src={Reading} alt="Reading Book" />
              <span>{t("about.readingBook")}</span>
            </div>
          </div>
        </div>
      </div>

      <div
        className="row about-content"
        style={{
          marginTop: "50px",
        }}
      >
        <div className="col-twelve">
          <h3>{t("about.skills")}</h3>

          <div className="skills">
            <div className="skill">
              <img src={HTML} alt="HTML" />
              <span>HTML</span>
            </div>
            <div className="skill">
              <img src={CSS} alt="CSS" />
              <span>CSS</span>
            </div>
            <div className="skill">
              <img src={JS} alt="Javascript" />
              <span>Javascript</span>
            </div>
            <div className="skill">
              <img src={Bootstrap} alt="Bootstrap" />
              <span>Bootstrap</span>
            </div>
            <div className="skill">
              <img src={MUI} alt="Material UI" />
              <span>Material UI</span>
            </div>
            <div className="skill">
              <img src={Tailwind} alt="Tailwind CSS" />
              <span>Tailwind CSS</span>
            </div>
            <div className="skill">
              <img src={ReactIcon} alt="React" />
              <span>React</span>
            </div>
            <div className="skill">
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original-wordmark.svg"
                alt="Next.js"
              />
              <span>Next.js</span>
            </div>
            <div className="skill">
              <img src={Angular} alt="Angular" />
              <span>Angular</span>
            </div>
            <div className="skill">
              <img src={Typescript} alt="Typescript" />
              <span>Typescript</span>
            </div>
            <div className="skill">
              <img src={ReactNative} alt="React Native" />
              <span>React Native</span>
            </div>
            <div className="skill">
              <img src={Ionic} alt="Ionic" />
              <span>Ionic</span>
            </div>
            <div className="skill">
              <img src={Firebase} alt="Firebase" />
              <span>Firebase</span>
            </div>
            <div className="skill">
              <img src={Parse} alt="Parse" />
              <span>Parse</span>
            </div>
            <div className="skill">
              <img src={NodeJS} alt="Node.js" />
              <span>Node.js</span>
            </div>
            <div className="skill">
              <img
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original-wordmark.svg"
                alt="Express.js"
              />

              <span>Express.js</span>
            </div>
            <div className="skill">
              <img src={Mongo} alt="MongoDB" />
              <span>MongoDB</span>
            </div>
            <div className="skill">
              <img src={SQL} alt="SQL" />
              <span>SQL</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
